import isEqual from 'lodash/isEqual';
import { usePreviousDeep } from '../hooks/usePreviousDeep';
import { useBosForm } from './useBosForm';
export const useBosFormWithSearchSync = (schema, navigationParams, params) => {
    const defaultValues = {
        ...params?.defaultValues,
        ...navigationParams.search,
    };
    const form = useBosForm(schema, {
        ...params,
        defaultValues,
    });
    const data = form.watch();
    const prevData = usePreviousDeep(data);
    if (!isEqual(data, prevData))
        navigationParams.navigate(data);
    return form;
};
